import { useState } from "react";
import { Card, Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { Error } from "ui-components/Alert";
import { getStockAttributesList } from "services/data.inventory.service";
import { useCustomerValue } from "providers/CustomerContext";
import StockAttributesDrawer from "./components/StockAttributesDrawer";
import { TableCard } from "ui-components/Layout";
import { useTeamValue } from "providers/TeamContext";

function StockAttributesList() {
  const {permissions, allowAll} = useTeamValue();
  const { customerCode } = useCustomerValue();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [data, setData] = useState([]);
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  const addPermission = allowAll || (Boolean(permissions["Stock Attributes"]) && permissions["Stock Attributes"].findIndex(b => b==="new") !== -1);
  
  useQuery({
    queryKey: ["stock-attributes-list", customerCode],
    queryFn: () => getStockAttributesList({ customerCode }),
    onSuccess: (data) => {
      setData(data.data.data);
    },
    onError,
  });

  const onNew = () => navigate("/inventory/stock-attributes/edit");

  const [sAttributesRequest, setSAttributesRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const drawerProp = { open, setOpen, sAttributesRequest, setSAttributesRequest };
  const columns = [
    {
      header: "Stock Attributes No",
      accessorKey: "stockAttributesNo",
      cell: ({ row }) => {
        const { stockAttributesNo } = row.original;
        return (
          <span
            style={{ color: "#1A73E8", cursor: "pointer", textDecoration: "underline" }}
            onClick={() => {
              setOpen(true);
              setSAttributesRequest({ stockAttributesNo, customerCode });
            }}
          >
            {stockAttributesNo}
          </span>
        );
      },
    },
    { header: "Warehouse Code", accessorKey: "warehouseCode" },
    { header: "Created Date", accessorKey: "createdOn" },
    { header: "Created By", accessorKey: "createdBy" },
  ];

  return (
    <ListLayout>
      <StockAttributesDrawer {...drawerProp} />
      {alert}
      {dialog}

      <TableCard sx={{ my: 3 }}>
        <MDBox display="flex" justifyContent="space-between" margin="10px">
          <MDButton variant="gradient" color="info" disabled={!addPermission} onClick={onNew}>
            <Icon>add</Icon>&nbsp;stock&nbsp;attributes
          </MDButton>
        </MDBox>
        <BasicTable columns={columns} data={data} />
      </TableCard>
    </ListLayout>
  );
}

export default StockAttributesList;
